<template>
  <!-- 继续率系数 -->
  <div class="td">
    <Dropdown :visible="visible" trigger="custom" @mouseleave.native="closePreview" placement="left">
      <div class="btn" @mouseover="openPreview" @click="openConfigModal('renewalRateConfigModal')">
        <span v-if="topItem.sourceType == 2">{{ topItem.isExistCoefficient ? '已配置' : '配置' }}</span>
        <span v-else>{{ topItem.isExistCoefficient ? '查看' : '-' }}</span>
      </div>
      <template slot="list">
        <div class="list-item" v-if="list.length">
          <div class="tools-box">
            <span>继续率系数</span>
          </div>
          <div class="table" style="width: 800px">
            <div class="tr">
              <div class="td th first-td">继续率指标</div>
              <div class="table-box">
                <div class="tr">
                  <div class="td th td2">继续率比例</div>
                  <div class="table-box" v-for="head in topItem.commissionItems" :key="head.id">
                    <div class="tr">
                      <div class="td th">{{ head.productName }}</div>
                    </div>
                    <div class="tr">
                      <div class="td th" v-for="head2 in head.programBaseList" :key="head2.id">{{ head2.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tr" v-for="row in list" :key="row.key">
              <div class="td first-td">
                <span v-if="row.indexValue == 1">R13</span>
                <span v-if="row.indexValue == 2">R25</span>
                <span v-if="row.indexValue == 3">R37</span>
                <span v-if="row.indexValue == 4">R49</span>
              </div>
              <div class="table-box">
                <div class="tr" v-for="row2 in row.coefficientItemList" :key="row2.key">
                  <div class="td td2">
                    <span>{{ row2.ratioStart }}%</span>
                    <span v-if="row2.ratioStartSymbol == 1">{{ '<' }}</span>
                    <span v-if="row2.ratioStartSymbol == 2">{{ '≤' }}</span>
                    <span>R</span>
                    <span v-if="row2.ratioEndSymbol == 1">{{ '<' }}</span>
                    <span v-if="row2.ratioEndSymbol == 2">{{ '≤' }}</span>
                    <span>{{ row2.ratioEnd }}%</span>
                  </div>
                  <div class="table-box" v-for="row3 in row2.coefficientValueGradeList" :key="row3.key">
                    <div class="tr">
                      <div class="td" v-for="row4 in row3.coefficientValueItemList" :key="row4.key">
                        {{ row4.coefficient ? row4.coefficient + '%' : '-' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="list.length == 0">
          <!-- 商户的团险-->
          <div class="empty-item" v-if="topItem.productCategory != 3 && topItem.sourceType == 2">该配置暂未开放，请耐心等待</div>
          <!-- 非商户的团险 -->
          <div class="empty-item" v-else>未配置</div>
        </template>
      </template>
    </Dropdown>
  </div>
</template>
  
<script>
import renewalRateConfig from './renewalRateConfig.config.js';
import common from './common.config.js';
export default {
  mixins: [renewalRateConfig, common],
  components: {},
  props: {
    topItem: null
  },
  data() {
    return {
      visible: false,
      over: false, //是否停留
      timer: null,
      list: []
    };
  },
  computed: {},
  created() {},
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.table {
  max-width: 700px;
  overflow-x: auto;
  .tr {
    .td {
      flex: 160px;
      min-width: 160px;
    }
    .first-td {
      flex: 120px;
      min-width: 120px;
    }
    .td2 {
      flex: 200px;
      min-width: 200px;
    }
  }
}
</style>  